import styled, { css } from 'styled-components';

import { TMarginSizes, TParagraphProperties } from './paragraph.types';

function handleMarginSize(marginSize: TMarginSizes): string {
    switch (marginSize) {
        case 'none':
            return '0';

        case 'small':
            return '0.8rem';

        case 'medium':
        default:
            return '1.6rem';

        case 'large':
            return '2.4rem';

        case 'xlarge':
            return '3.2rem';

        case 'xxlarge':
            return '4.8rem';
    }
}

export const StyledParagraph = styled.p<TParagraphProperties>`
    margin-top: ${({ marginTop }) =>
        handleMarginSize(marginTop as TMarginSizes)};
    margin-bottom: ${({ marginBottom }) =>
        handleMarginSize(marginBottom as TMarginSizes)};
    color: ${({ theme, color }) => (color ? theme.color[color] : 'initial')};
    text-align: ${({ align }) => align ?? 'left'};

    @media (min-width: ${properties =>
            properties.theme.deprecatedScreen.tabletLandscapeMinimum}),
        print {
        line-height: 1.5;
    }

    ${({ small }) =>
        small
            ? css`
                  font-size: 1.4rem;
                  line-height: 2rem;
              `
            : null}
`;
